export enum DesignsTab {
    DESIGNS = 'designs',
    PROJECTS = 'projects',
}

export type DesignsTabsProps = {
    activeTab: DesignsTab;
    isLocked?: boolean;
    isListView?: boolean;
};
